/**
 * Shared mutable state for Cardistry scenes — replaces the global
 * `config` and `gameState` that the original code used.
 */
import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio: {
    bgaudio: null,
    yayAudio: null,
  },
};

export const gameState = {
  score: 0,
  attempted: 0,
  questionNumber: 0,
  hints: 0,
  gameWin: false,
};

export function resetGameState() {
  gameState.score = 0;
  gameState.attempted = 0;
  gameState.questionNumber = 0;
  gameState.hints = 0;
  gameState.gameWin = false;
}
